import PropTypes from 'prop-types';
import React from 'react';
import BetLink from 'modules/Common/containers/BetLink';
import { MATCH_STATE_ALL } from 'modules/Football/consts';

export default function FootballMatchOdds(props) {
  require("./FootballMatchOdds.scss");

  const {
    competition: {
      name: eventCompetition // only relevant for feature "integrated-betslip"
    } = {},
    match_betting_market: {
      match_betting: matchBetting,
      market_suspended: suspended,
      fixture: fixture,
      live = false
    } = {},
    match_reference: matchReference,
    match_date: matchDate,
    team_score_a : {
      team : {
        name : teamA
      }
    },
    team_score_b : {
      team : {
        name : teamB
      }
    },
    state: matchState
  } = props.match;

  function matchShouldShowOdds(state) {
    return (state !== "ABANDONED" && MATCH_STATE_ALL.includes(state)
      && MATCH_STATE_ALL.indexOf(state) < MATCH_STATE_ALL.indexOf("FULLTIME90"));
  }

  function generateBetLinkProps(eventId, betting, isLive) {
    const {
      market_reference: {
        external_reference: [
          {
            value: marketId
          } = {}
        ] = []
      } = {},
      bet_reference: {
        external_reference: [
          {
            value: betId
          } = {}
        ] = []
      } = {},
      name: betName,
      has_sp: startingPriceAvailable,
      odds
    } = betting;

    return {
      eventName: `${teamA} v ${teamB}`,
      eventCompetition,
      dateTime: matchDate,
      sport: "football",
      isLive,
      marketId,
      eventId,
      betId,
      betName,
      odds,
      suspended,
      fixture,
      startingPriceAvailable
    };
  }

  let skybetRefs = matchReference && matchReference.external_reference && matchReference.external_reference.filter(r => r.ref === 'skybet').map(r => r.value) || [];
  let eventRef = skybetRefs.length > 0 ? skybetRefs[0] : '';

  let teamABetting = matchBetting && matchBetting.filter(b => b.name === teamA) || [];
  let drawBetting = matchBetting && matchBetting.filter(b => b.name === "Draw") || [];
  let teamBBetting = matchBetting && matchBetting.filter(b => b.name === teamB) || [];

  if (!matchShouldShowOdds(matchState)) {
    return null;
  }

  return(
    <div className="matchOdds">
        {
          teamABetting.length > 0 ?
            <BetLink className="odds" {...generateBetLinkProps(eventRef, teamABetting[0], live)}>{teamABetting[0].odds}</BetLink>
          : <span className="odds">-</span>
        }
        {
          drawBetting.length > 0 ?
            <BetLink className="odds" {...generateBetLinkProps(eventRef, drawBetting[0], live)}>{drawBetting[0].odds}</BetLink>
          : <span className="odds">-</span>
        }
        {
          teamBBetting.length > 0 ?
            <BetLink className="odds" {...generateBetLinkProps(eventRef, teamBBetting[0], live)}>{teamBBetting[0].odds}</BetLink>
          : <span className="odds">-</span>
        }
    </div>
  )
}

FootballMatchOdds.propTypes = {
  match: PropTypes.shape({
    match_betting_market: PropTypes.shape({
      match_betting: PropTypes.array,
      live: PropTypes.bool,
      market_suspended: PropTypes.bool,
      fixture: PropTypes.string
    }),
    matchExternalRefs: PropTypes.object,
    teamA: PropTypes.string,
    teamB: PropTypes.string
  })
};



// WEBPACK FOOTER //
// ./modules/Football/components/FootballMatchOdds.js